import { render, staticRenderFns } from "./ArchivedListComponent.vue?vue&type=template&id=6f6da08a"
import script from "./ArchivedListComponent.vue?vue&type=script&lang=js"
export * from "./ArchivedListComponent.vue?vue&type=script&lang=js"
import style0 from "./ArchivedListComponent.vue?vue&type=style&index=0&id=6f6da08a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports